import { Dialog } from '@material-ui/core';
import { useResponsiveValue } from '@superdispatch/ui';
import { InstantTransferMultipleSettleDialogContent } from 'shared/modules/superpay/instant-transfer-settle/InstantTransferMultipleSettleDialogContent';
import { useInstantTransferMultipleSettleInformation } from 'shared/modules/superpay/SuperPayAPI';

interface InstantTransferMultipleSettleDialogProps {
  open: boolean;
  onSuccess: () => void;
  onClose: () => void;
}

export function InstantTransferMultipleSettleDialog({
  open,
  onClose,
  onSuccess,
}: InstantTransferMultipleSettleDialogProps) {
  const isMobile = useResponsiveValue(true, true, false);

  const { data: settleInformation, isLoading } =
    useInstantTransferMultipleSettleInformation({
      enabled: open,
      refetchOnWindowFocus: false,
    });

  return (
    <Dialog
      open={open && !isLoading}
      onClose={onClose}
      maxWidth={false}
      fullWidth={isMobile}
    >
      <InstantTransferMultipleSettleDialogContent
        onClose={onClose}
        onSuccess={onSuccess}
        settleInformation={settleInformation}
      />
    </Dialog>
  );
}
